// services/apiConfig.ts 
import axios from 'axios';
export const baseURL = import.meta.env.VITE_API_REST_BASE_URL
const apiUrl = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  // withCredentials: true, // agar login auth token/cookies use kar rahe ho
});

export default apiUrl;
